import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import type { Notification } from '@/_types/models/notifications';

export const getNotifications = async ({
  token,
}: APIRequest): APIResponsePromise<Array<Notification>> =>
  await _callBackend('/advisors/get_all_notifications', 'GET', null, token);

export interface GetNotificationsResponse {
  current_page: number;
  notifications: Array<Notification>;
  per_page: number;
  total: number;
  unread_count: number;
}

export const getPaginatedNotifications = async ({
  page,
  search,
  isUnreadOnly,
  type = '',
  token,
}: APIRequest<{
  page: number;
  type: string;
  search: string;
  isUnreadOnly: boolean;
}>): APIResponsePromise<GetNotificationsResponse> =>
  await _callBackend(
    `/advisors/get_paginated_notifications?page=${page}&search=${encodeURIComponent(search)}&is_unread_only=${isUnreadOnly}&type=${encodeURIComponent(type)}`,
    'GET',
    null,
    token,
  );

export const dismissNotification = async ({
  notificationId,
  token,
}: APIRequest<{ notificationId: number }>): APIResponsePromise =>
  await _callBackend(
    `/advisors/dismiss_notification/?id=${notificationId}`,
    'GET',
    null,
    token,
  );

export const dismissAllNotifications = async ({
  token,
}: APIRequest): APIResponsePromise =>
  await _callBackend('/advisors/dismiss_all_notifications', 'GET', null, token);
